import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import React, { useState } from 'react';
import { Form, Image, Button as Butt } from 'antd';
import { RcFile } from "antd/es/upload";
import { Card } from 'antd';
import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import { DeleteForever, DownloadOutlined } from "@mui/icons-material";


const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

export const Tab3 = (props: { form: any, photo?: string, signature?: string }) => {

    const [photo, setphoto] = useState<any>(props.photo);
    const [Signature, setSignature] = useState<any>(props.signature);
    const [loading, setLoading] = useState(false);
    const [photoKey, setPhotoKey] = useState(0);
    const [signatureKey, setSignatureKey] = useState(0);

    function Delete(Option: number) {
        if (Option === 1) { setphoto(''); props.form.setFieldValue('Photo', ''); setPhotoKey(prev => prev + 1); }
        else if (Option === 2) { setSignature(''); props.form.setFieldValue('Signature', ''); setSignatureKey(prev => prev + 1); }
    }

    const onChange: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
        setLoading(true);
        let file = undefined;

        if (newFileList[0]?.originFileObj) {
            file = await getBase64(newFileList[0].originFileObj as RcFile);
            props.form.setFieldValue("Photo", file);
            setphoto(file);
            setLoading(false);
        }
        setLoading(false);
    };

    const onChangeSign: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
        setLoading(true);
        let file = undefined;

        if (newFileList[0]?.originFileObj) {
            file = await getBase64(newFileList[0].originFileObj as RcFile);
            props.form.setFieldValue("Signature", file);
            setSignature(file);
        }
        setLoading(false);
    };

    setTimeout(() => {
        setphoto(props.form.getFieldValue("Photo"));
        setSignature(props.form.getFieldValue("Signature"));
    }, 1000)

    return (
        <>
            <div className='tabItem' >
                <Grid container className='border-left border' sx={{ width: "85%", position: "absolute" }}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={12} md={6} className='border-left'>

                                <Card
                                    title="Photo du Client Promoteur "
                                    extra={[
                                        <>
                                            <Box sx={{ display: 'flex' }} gap={2}>
                                                <Box>
                                                    <Form.Item name="Photo" rules={[{ required: true, message: 'la photo est Obligatoire' }]}  >
                                                        <Upload key={photoKey} showUploadList={false} onChange={e => { onChange(e) }} >
                                                            <Butt type="dashed" shape="default" icon={<DownloadOutlined />} style={{ marginTop: '0.5em' }} >
                                                                Upload Image
                                                            </Butt>
                                                        </Upload>
                                                    </Form.Item>
                                                </Box>
                                                <Box>
                                                    <Butt type="dashed" disabled={props.form.getFieldValue('Photo') !== '' ? false : true} shape="default" onClick={e => { Delete(1) }} icon={<DeleteForever color="error" />} style={{ marginTop: '0.5em' }} >
                                                    </Butt>
                                                </Box>
                                            </Box>
                                        </>,
                                    ]}
                                    hoverable cover={<Image alt="Photo Client" src={photo} style={{ maxHeight: 400 }} />}   >
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={6} className='border-left'>
                                <Card
                                    title="Signature  du Client Promoteur "
                                    extra={[
                                        <>
                                            <Box sx={{ display: 'flex' }} gap={2}>
                                                <Box>
                                                    <Form.Item name="Signature" rules={[{ required: true, message: 'Signature  photo est Obligatoire' }]}  >
                                                        <Upload key={signatureKey} showUploadList={false} onChange={e => { onChangeSign(e) }} >
                                                            <Butt type="dashed" icon={<DownloadOutlined />} style={{ marginTop: '0.5em' }} >
                                                                Upload Signature
                                                            </Butt>
                                                        </Upload>
                                                    </Form.Item>
                                                </Box>
                                                <Box>
                                                    <Butt type="dashed" disabled={props.form.getFieldValue('Signature') !== '' ? false : true} shape="default" onClick={e => { Delete(2) }} icon={<DeleteForever color="error" />} style={{ marginTop: '0.5em' }} >
                                                    </Butt>
                                                </Box>
                                            </Box>
                                        </>,
                                       
                                    ]}
                                    hoverable
                                    cover={<Image alt="Signature Client" src={Signature} style={{ maxHeight: 400 }} />} >
                                </Card>
                            </Grid>
                            <Grid item>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </>
    );

}